<template>
  <InfoBlock :title="state.title" :text="state.text" :type="state.type" />
</template>

<script setup lang="ts">
import type { ICmsContentInfoBlocks } from '~~/types/_cms-types';
import type { TInfoBlock } from '~~/types/local_types';

interface IProps extends ICmsContentInfoBlocks {
  text: { blocks: Array<never> } | undefined;
  title: string;
  badge?: string;
}

const props = withDefaults(defineProps<IProps>(), {
  text: undefined,
  title: undefined,
  badge: undefined,
});

const state = reactive({
  text: props.text,
  title: props.title,
  type: (props.badge as TInfoBlock) === null ? 'default' : props.badge,
});
</script>
